import React from "react";
import PropTypes from "prop-types";
import { Select, MenuItem } from "@material-ui/core";
import { PLAN_OPTIONS } from "../constants/planOptions";

/**
 * Reusable plan selector dropdown component
 */
export const PlanSelector = ({ value, onChange, labelId = "plans-select" }) => {
  return (
    <Select label="Plans" labelId={labelId} value={value} onChange={onChange}>
      {PLAN_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

PlanSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelId: PropTypes.string,
};

